import React from 'react';
import { consumeCalendarReturnContext } from '../calendarSessionState';

export function useCalendarModals(calendarPath) {
  const [returnContext] = React.useState(() => consumeCalendarReturnContext(calendarPath));
  const [task, setTask] = React.useState(null);
  const [modalOpenTask, setModalOpenTask] = React.useState(false);
  const [taskView, setTaskView] = React.useState(returnContext?.task || null);
  const [taskViewMember, setTaskViewMember] = React.useState(returnContext?.member || null);
  const [modalOpenTaskView, setModalOpenTaskView] = React.useState(Boolean(returnContext?.task));
  const [openRemoveModal, setOpenRemoveModal] = React.useState(false);
  const [removeEntityId, setRemoveEntityId] = React.useState(null);

  const openCreateTask = React.useCallback(() => {
    setTask(null);
    setModalOpenTask(true);
  }, []);

  const closeModalTask = React.useCallback(() => {
    setModalOpenTask(false);
    setTask(null);
  }, []);

  const closeModalTaskView = React.useCallback(() => {
    setModalOpenTaskView(false);
    setTaskView(null);
    setTaskViewMember(null);
  }, []);

  const closeRemoveModal = React.useCallback(() => {
    setOpenRemoveModal(false);
    setRemoveEntityId(null);
  }, []);

  const openTaskView = React.useCallback((rawTask) => {
    setTaskView(rawTask ?? null);
    setTaskViewMember(null);
    setModalOpenTaskView(true);
  }, []);

  const handleEditFromView = React.useCallback((fullTask) => {
    setModalOpenTaskView(false);
    setTaskView(null);
    setTask(fullTask || null);
    setModalOpenTask(true);
  }, []);

  const handleRemoveFromView = React.useCallback((fullTask) => {
    const eventId = fullTask?.id ?? fullTask?.raw?.id ?? null;
    if (!eventId) return;

    setModalOpenTaskView(false);
    setTaskView(null);
    setRemoveEntityId(eventId);
    setOpenRemoveModal(true);
  }, []);

  return {
    closeModalTask,
    closeModalTaskView,
    closeRemoveModal,
    handleEditFromView,
    handleRemoveFromView,
    modalOpenTask,
    modalOpenTaskView,
    openCreateTask,
    openRemoveModal,
    openTaskView,
    removeEntityId,
    task,
    taskView,
    taskViewMember,
  };
}
